var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slice',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
    active: true,
    callback: _vm.onWaypoint,
    options: _vm.intersectionOptions,
  }),expression:"{\n    active: true,\n    callback: onWaypoint,\n    options: intersectionOptions,\n  }"}],staticClass:"slice--image-full",class:{
    container: !_vm.isFull,
    image45: _vm.is4_5,
    'image-in-screen': _vm.imageInScreen,
    'image-height-auto': _vm.block.image_height_auto,
  },style:(_vm.style),attrs:{"id":_vm.block._key}},[_c('div',{staticClass:"slice__inner",class:{ 'row-md justify-center': !_vm.isFull }},[(_vm.image)?_c('div',{staticClass:"slice__image",class:{
        'col-md-8': !_vm.isFull && !_vm.is4_5,
        'image-portrait': _vm.is4_5 && _vm.block.format === 'portrait',
      }},[_c('image-with-products',{attrs:{"image-desktop":{
          image: _vm.image,
          sizes: _vm.size,
        },"image-mobile":!_vm.block.image_height_auto
            ? {
                image: _vm.image,
                widths: [320, 414, 640, 769],
              }
            : undefined}}),_vm._v(" "),(_vm.block.caption)?_c('p',{staticClass:"slice--image-full__caption text-small text-italic"},[_vm._v("\n        "+_vm._s(_vm.block.caption)+"\n      ")]):_vm._e()],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }